export const TiifaIcon = () => {
  return (
    <div className="flex justify-center items-center mt-4">
      <img className="w-60" src="/assets/tiifa-icon.png" />
    </div>
  );
};
